import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "sys-menu" }
const _hoisted_5 = { class: "right" }

import Top from "@/components/Top.vue";
import { ref ,getCurrentInstance} from "vue";
import { ElMessageBox } from "element-plus/es";
import { logout } from "@/api/Login";
import AccountApi from "@/api/AccountApi";

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { proxy } = getCurrentInstance();
const list = ref([
  { text: "个人信息", url: "/index/system/user", active: true },
  { text: "修改密码", url: "/index/system/pwd", active: false },


]);
const vimLogout = () => {
  ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    logout().then(() => {
      proxy.$ws.close();
      AccountApi.toLogin();
    });
  });
};


const handleClick = (item: any) => {
  list.value.forEach((item) => {
    item.active = false;
  });
  item.active = true;
};

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 20 }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "text" }, "设置", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "add"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_scrollbar, { class: "list" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(item.active ? 'active' : '')
              }, [
                _createVNode(_component_router_link, {
                  to: item.url,
                  class: "block",
                  onClick: ($event: any) => (handleClick(item))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      style: _normalizeStyle(item.active ? {'color':'#fff' }: '')
                    }, _toDisplayString(item.text), 5)
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"])
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              onClick: vimLogout,
              style: {"cursor":"pointer"}
            }, " 退出 ")
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view, { class: "main-view" }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1024))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})